<!-- <form *ngIf="question" name="frmQuestion" #frmQuestion="ngForm"> -->
<div *ngIf="question">
    <div class="row" >
        <div class="col-4">
            <label [ngClass]="{'ml-4':questionLevel!=0}" *ngIf="labelBefore" class="control-label" [paflabel]="lblCod"></label>
        </div>
        
        <div class="col-1 mt-1 d-flex">
            <input type="radio" [name]="nameTrue" [value]="false" [(ngModel)]="value" kendoRadioButton required [disabled]="readonly" />
            <div class="col-1 mt-1 ml-1"><label paflabel="Non"></label></div>
        </div>        
        <div class="col-auto mt-1 d-flex">
            <input type="radio" [name]="nameFalse" [value]="true" [(ngModel)]="value" kendoRadioButton  required [disabled]="readonly" />
            <div class="col-auto mt-1 ml-1"><label paflabel="Oui"></label></div>
        </div>
        
        <div class="col-auto"><label *ngIf="!labelBefore" class="control-label" [paflabel]="lblCod"></label></div>
        <div class="col">
            <label class="control-label text-primary" *ngIf="value === true && question?.TrueLblCod" [paflabel]="question?.TrueLblCod"></label>
            <label class="control-label text-primary" *ngIf="value === false && question?.FalseLblCod" [paflabel]="question?.FalseLblCod"></label>
        </div>
    </div>
    
    <div *ngIf="showTrueQuestion">       
        <question-row [questionId]="trueQuestion.Id" [visibleQuestions]="visibleQuestions" [answers]="answers" [questionLevel]="questionLevel+1" [readonly]="readonly">
        </question-row>
    </div>
    <div *ngIf="showFalseQuestion">
            <question-row [questionId]="falseQuestion.Id" [visibleQuestions]="visibleQuestions" [answers]="answers" [questionLevel]="questionLevel+1" [readonly]="readonly">
            </question-row>
    </div>
</div>
<!-- </form> -->